// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qc-0";